export type ISearchParamItem = string | string[];

export function getLastQuery( item: ISearchParamItem ): string {

    if ( Array.isArray( item )) {

        if ( item.length === 0 ) {

            return '';

        }
        return item[item.length - 1];

    }

    switch ( typeof item ) {

        case 'string':
            return item;

        case 'number':
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            return `${item}`;

        default:
            break;

    }

    if ( item == null ) {

        return '';

    }

    return item;

}

export function getFirstQuery( item: ISearchParamItem ): string {

    if ( Array.isArray( item )) {

        if ( item.length === 0 ) {

            return '';

        }
        return item[0];

    }

    switch ( typeof item ) {

        case 'string':
            return item;

        case 'number':
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            return `${item}`;

        default:
            break;

    }

    if ( item == null ) {

        return '';

    }

    return item;

}

const paramsMap = {
    subId: 's_id',
    prevSubId: 'ps_id',
    prev_sub_id: 'ps_id',
    order_id: 'o_id',
    plan_id: 'p_id',
    prevPlan: 'pp_id'
};

export const paramsKeys = Object.keys( paramsMap );

export const checkOldUrlParams = ( url: string ): boolean => {

    const urlObj = new URL( url );
    const searchParams = new URLSearchParams( urlObj.search );

    // 检查是否有旧的参数
    for ( const key of searchParams.keys()) {

        if ( paramsKeys.includes( key )) {

            return true;

        }

    }

    return false;

};

// 定义一个函数将旧的参数映射到新的参数
export const convertUrlParams = ( url: string ): string => {

    const urlObj = new URL( url );
    const searchParams = new URLSearchParams( urlObj.search );

    // 如果是旧参数，做相应的转换
    for ( const key of searchParams.keys()) {

        if ( paramsKeys.includes( key )) {

            searchParams.set( paramsMap[key], searchParams.get( key )! );
            searchParams.delete( key );

        }

    }

    // 返回转换后的新URL
    urlObj.search = searchParams.toString();
    return urlObj.toString();

};

// 获取转换后的新 URL
// let newUrl = convertUrlParams(url);

// 在 WebView 中加载新 URL
// window.location.href = newUrl;
